import AppleIcon from '@mui/icons-material/Apple';
import DownloadIcon from '@mui/icons-material/Download';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import { Product } from '../firebase';
import { saveUrl } from '../ostium/util';
import { TypeOcrH6 } from './Types';
import { useUser } from './UserProvider';

function Microsoft() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
    >
      <path
        fill='currentColor'
        d='M2 3h9v9H2V3m9 19H2v-9h9v9M21 3v9h-9V3h9m0 19h-9v-9h9v9Z'
      />
    </svg>
  );
}

function headerSmall(text: string) {
  return (
    <TypeOcrH6 noWrap sx={{ m: 1 }}>
      {text}
    </TypeOcrH6>
  );
}

function getPrettyOs(inst: Product) {
  if (inst.os === 'osx') {
    return 'Mac 10.14+ (Intel 64 and Arm 64)';
  }
  if (inst.os === 'w64') {
    return 'Windows 10+ (Intel 64)';
  }
  return inst.os;
}

function getPrettyRelease(inst: Product) {
  if (inst.release === 'public') {
    return '';
  } else {
    return inst.release;
  }
}

function getPrettyName(inst: Product) {
  return `${getPrettyOs(inst)} ${inst.version} ${getPrettyRelease(inst)}`;
}

export default function Installers() {
  const user = useUser();
  const pluginNamesDict: any = {};
  for (const p of user.plugins) {
    pluginNamesDict[p.name] = p.name;
  }
  const pluginNames: string[] = Object.keys(pluginNamesDict);
  pluginNames.sort();
  //const pluginList = pluginNames.join(", ");

  const installers = user.installers;
  installers.sort();

  const installersMac = installers.filter((inst) => {
    return inst.os === 'osx';
  });
  const installersWin = installers.filter((inst) => {
    return inst.os === 'w64';
  });
  return (
    <Stack justifyContent='center'>
      <Stack direction='row' sx={{ mt: 0 }} justifyContent='center'>
        <DownloadIcon sx={{ mt: 1.4 }}></DownloadIcon>
        {headerSmall('Get Installer')}{' '}
        <DownloadIcon sx={{ mt: 1.4 }}></DownloadIcon>
      </Stack>

      <Stack direction='row' sx={{ mt: 2 }} justifyContent='center'>
        <AppleIcon sx={{ mx: 0.5 }}>Mac</AppleIcon>
        <TypeOcrH6>{'Mac'}</TypeOcrH6>
      </Stack>
      {installersMac.map((inst: any) => {
        const name = getPrettyName(inst);
        return (
          <Box sx={{ m: 1 }} key={name} justifyContent='center' display='flex'>
            <Link
              onClick={async () => {
                saveUrl(await inst.getBin(), inst.file);
              }}
              component='button'
              key={name}
            >
              {name}
            </Link>
          </Box>
        );
      })}

      <Stack direction='row' sx={{ mt: 4 }} justifyContent='center'>
        <SvgIcon sx={{ mx: 0.5 }}>
          <Microsoft />
        </SvgIcon>
        <TypeOcrH6>{'Windows'}</TypeOcrH6>
      </Stack>
      {installersWin.map((inst: any) => {
        const name = getPrettyName(inst);
        return (
          <Box sx={{ m: 1 }} key={name} justifyContent='center' display='flex'>
            <Link
              sx={{ my: 0 }}
              onClick={async () => {
                saveUrl(await inst.getBin(), inst.file);
              }}
              component='button'
              key={name}
            >
              {name}
            </Link>
          </Box>
        );
      })}
    </Stack>
  );
}
